import script from "./buttonGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./buttonGroup.vue?vue&type=script&setup=true&lang=js"

import "./buttonGroup.vue?vue&type=style&index=0&id=6996fc50&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6996fc50"]])

export default __exports__